import { FileClock } from "lucide-react";
import { DocumentCard } from "@/components/DocumentCard";
import { Reveal } from "@/components/Reveal";
import { asArray } from "@/lib/api";
import { useFetch } from "@/lib/hooks";

export function RecentList({ limit = 6 }) {
  const { data, loading } = useFetch(`/documents/recent?limit=${limit}`, []);
  const docs = asArray(data);
  if (loading) {
    return <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">{[0, 1, 2].map((i) => <div key={i} className="ph2-shimmer h-64 rounded-[1.5rem]" />)}</div>;
  }
  if (!docs.length) {
    return (
      <div className="flex flex-col items-center rounded-[1.75rem] border border-dashed border-ph-line bg-ph-surface/60 px-6 py-16 text-center" data-testid="recent-empty">
        <FileClock className="h-10 w-10 text-ph-accent" />
        <p className="mt-4 font-display text-2xl font-bold text-ph-ink">No price lists published yet</p>
        <p className="mt-2 max-w-md text-sm text-ph-muted">Newly uploaded and replaced price lists will appear here the moment an administrator publishes them.</p>
      </div>
    );
  }
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-testid="recent-list">
      {docs.map((d, i) => <Reveal key={d.id} delay={(i % 3) * 0.08}><DocumentCard doc={d} /></Reveal>)}
    </div>
  );
}
